(function() {
    angular.module('emarket.commons').directive('emAccordion', function() {
        return {            
            replace: true,
            transclude: true,
            template: '<div class="em-accordion" ng-transclude></div>',
            controller: [ function() {
                var items = [];

                this.register = function(item) {
                    items.push(item);

                    if (items.length < 2) {
                        item.isVisible = true;
                    }
                };

                this.handleSelectedItem = function(selectedItem) {
                    angular.forEach(items, function(item) {
                        if (selectedItem !== item) {
                            item.isVisible = false;
                        }            else {
                            item.isVisible = true;
                        }
                    });
                };
            } ]
        };
    });
}());
